module.exports = __webpack_public_path__ + "static/media/Picture50.40751e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture50.png
// module id = 1542
// module chunks = 0